module.exports = __webpack_public_path__ + "static/media/check_color.818daca9.svg";